<template>
    <div>
        <div class="subsection">
            <div class="title">Automātiski ģenerētā priekšmeta vēsture</div>
            <div class="actions">
                <button class="btn btn-sm btn-primary" @click="getItemEvents()">Ielādēt notikumus</button>
            </div>
        </div>
        <div v-if="loaded == true">
        <div class="col-12">
            <div class="table-header">Iekšējā kustība</div>
            <table class="table" v-if="internal_acts.length >0">
                <thead class="bg-light">
                    <tr>
                        <th>veids</th>
                        <th>numurs</th>
                        <th>datums</th>
                        <th>termiņš</th>
                        <th>mērķis</th>
                        <th>darbības</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="act in internal_acts" :key="'internal_act_'+act.id">
                        <td>
                            <span v-if="act.act_type == 'give'">Izsniegšana no krājuma</span>
                            <span v-if="act.act_type == 'receive'">Pieņemšana krājumā</span>
                            <span v-if="act.act_type == 'give_with_reference'">Izsniegšana no krājuma (papildus)</span>
                            <span v-if="act.act_type == 'receive_with_reference'">Pieņemšana krājumā (papildus)</span>
                            <span v-if="act.act_type == 'give_with_reference_extension'">Izsniegšana no krājuma (papildus)</span>
                            <span v-if="act.act_type == 'receive_with_reference_extension'">Pieņemšana krājumā (papildus)</span>
                            <span v-if="act.act_type == 'fact_finding'">Fakta konstatācijas akts</span>
                        </td>
                        <td>{{act.act_number}}</td>
                        <td>{{normalDate(act.act_date)}}</td>
                        <td>{{normalDate(act.due_date)}}</td>
                        <td>{{act.purpose}}</td>
                        <td><a v-if="show_link === true" :href="'/internal-acts/show/'+act.id" target="_blank"><span class="material-icons">visibility</span></a></td>
                    </tr>
                </tbody>
            </table>
            <div class="alert alert-primary text-center" v-else>Nav reģistrēts neviens notikums.</div>
        </div>
        <div class="col-12">
            <div class="table-header">Ārējā kustība</div>
            <table class="table" v-if="external_acts.length >0">
                <thead class="bg-light">
                <tr>
                    <th>numurs</th>
                    <th>datums</th>
                    <th>termiņš</th>
                    <th>mērķis</th>
                    <th>darbības</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="act in external_acts" :key="'external_act_'+act.id">
                    <td>{{act.act_number}}</td>
                    <td>{{normalDate(act.act_date)}}</td>
                    <td>{{normalDate(act.due_date)}}</td>
                    <td>{{act.purpose}}</td>
                    <td><a v-if="show_link === true" :href="'/external-acts/show/'+act.id" target="_blank"><span class="material-icons">visibility</span></a></td>
                </tr>
                </tbody>
            </table>
            <div class="alert alert-primary text-center" v-else>Nav reģistrēts neviens notikums.</div>
        </div>
            <div class="col-12">
                <div class="table-header">Novērtēšanas akti</div>
                <table class="table" v-if="evaluation_acts.length >0">
                    <thead class="bg-light">
                    <tr>
                        <th>numurs</th>
                        <th>datums</th>
                        <th>vērtība</th>
                        <th>darbības</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="act in evaluation_acts" :key="'evaluation_act_'+act.id">
                        <td>{{act.act_number}}</td>
                        <td>{{normalDate(act.act_date)}}</td>
                        <td>{{normalFloat(act.pivot.item_value)}}</td>
                        <td><a v-if="show_link === true" :href="'/evaluation-acts/show/'+act.id" target="_blank"><span class="material-icons">visibility</span></a></td>
                    </tr>
                    </tbody>
                </table>
                <div class="alert alert-primary text-center" v-else>Nav reģistrēts neviens notikums.</div>
            </div>
            <div class="col-12">
                <div class="table-header">Esības pārbaude</div>
                <table class="table" v-if="existence_acts.length >0">
                    <thead class="bg-light">
                    <tr>
                        <th>numurs</th>
                        <th>datums</th>
                        <th>vērtība</th>
                        <th>darbības</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="act in existence_acts" :key="'existence_acts_'+act.id">
                        <td>{{act.act_number}}</td>
                        <td>{{normalDate(act.act_date)}}</td>
                        <td>{{act.pivot.item_existence_value}}</td>
                        <td><a v-if="show_link === true" :href="'/existence-acts/show/'+act.id" target="_blank"><span class="material-icons">visibility</span></a></td>
                    </tr>
                    </tbody>
                </table>
                <div class="alert alert-primary text-center" v-else>Nav reģistrēts neviens notikums.</div>
            </div>
            <div class="col-12">
                <div class="table-header">Restaurācijas</div>
                <table class="table" v-if="restorations.length >0">
                    <thead class="bg-light">
                    <tr>
                        <th>nosaukums</th>
                        <th>datums no</th>
                        <th>datums līdz</th>
                        <th>restaurātors</th>
                        <th>apraksts</th>
                        <th>darbības</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="act in restorations" :key="'restorations_'+act.id">
                        <td>{{act.event_name}}</td>
                        <td>{{normalDate(act.start_date)}}</td>
                        <td>{{normalDate(act.end_date)}}</td>
                        <td>{{act.restorer}}</td>
                        <td class="pre-formatted">{{act.description}}</td>
                        <td><a v-if="show_link === true" :href="'/restorations/show/'+act.id" target="_blank"><span class="material-icons">visibility</span></a></td>
                    </tr>
                    </tbody>
                </table>
                <div class="alert alert-primary text-center" v-else>Nav reģistrēts neviens notikums.</div>
            </div>
        </div>

    </div>
</template>


<script>
export default{
    props:['id','show_link'],
    data()
    {
        return{
            loading:false,
            internal_acts:[],
            external_acts:[],
            elimination_acts:[],
            evaluation_acts:[],
            existence_acts:[],
            licences:[],
            restorations:[],
            loaded:false,
        }
    },
    methods:{
        normalDate(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY.')
            }
            else
            {
                return null;
            }
        },
        normalFloat(number)
        {
            if(number != null)
            {
                return parseFloat(number).toFixed(2);
            }
            return null;

        },
        getItemEvents(){
            var that = this;
            axios.post('/dashboard/api/get_item_events',{
                id: that.id
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.internal_acts=response.data.item.internal_acts;
                    that.external_acts=response.data.item.external_acts;
                    that.elimination_acts=response.data.item.elimination_acts;
                    that.evaluation_acts=response.data.item.evaluation_acts;
                    that.existence_acts=response.data.item.existence_acts;
                    that.licences=response.data.item.licences;
                    that.restorations=response.data.item.restorations;
                    that.$toast.open(response.data.message);
                    that.loaded = true;
                }
                else{
                    that.$toast.error(response.data.message);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header{
    font-size:16px;
    text-align: center;
    font-weight:bold;
}
.subsection
{
    width:100%;
    display:flex;
    align-items: center;
    padding-bottom:5px;
    padding-top:10px;
    border-bottom:solid 5px #eee;
    margin-bottom:15px;
    .title{
        font-size:18px;
        font-weight:bold;
    }
    .actions{
        margin-left:auto;
    }
}
</style>
